import { render, staticRenderFns } from "./riwayatJabatanPerangkat.vue?vue&type=template&id=39b0ed58&scoped=true&"
import script from "./riwayatJabatanPerangkat.vue?vue&type=script&lang=js&"
export * from "./riwayatJabatanPerangkat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b0ed58",
  null
  
)

export default component.exports